export default class Hover {
  constructor(element) {
    this.element = element;
    //Breakpoint tablette
    if (window.matchMedia('(min-width: 800px)').matches) {
      this.hovers = this.element.querySelectorAll('.js-hover');
      this.contents = this.element.querySelectorAll(`[data-hover-content-id]`);

      this.init();
    }
  }

  init() {
    for (let i = 0; i < this.hovers.length; i++) {
      const hover = this.hovers[i];

      hover.addEventListener('mouseover', this.activerHover.bind(this));
      hover.addEventListener('mouseout', this.fermerHover.bind(this));
    }
  }

  activerHover(event) {
    //console.log('Initialisation de ma composante Hover');
    const id = event.currentTarget.dataset.hoverId;
    for (let i = 0; i < this.contents.length; i++) {
      const content = this.contents[i];
      content.classList.remove('hover-is-active'); // Je garde au cas où. Ça peut remplacer un minimum fermerHover
      if (content.dataset.hoverContentId == id) {
        content.classList.add('hover-is-active');
      }
    }

    for (let i = 0; i < this.hovers.length; i++) {
      const hover = this.hovers[i];
      hover.addEventListener('mousemove', this.bougerHover.bind(this));
    }
  }

  bougerHover(event) {
    const id = event.currentTarget.dataset.hoverId;
    for (let i = 0; i < this.contents.length; i++) {
      const content = this.contents[i];
      if (content.dataset.hoverContentId == id) {
        content.style.top = event.pageY - 20 + 'px';
        content.style.left = event.pageX + 20 + 'px';
      }
    }

    //requestAnimationFrame(this.bougerHover.bind(this));
  }

  fermerHover(event) {
    const id = event.currentTarget.dataset.hoverId;
    for (let i = 0; i < this.contents.length; i++) {
      const content = this.contents[i];
      if (content.dataset.hoverContentId == id) {
        content.classList.remove('hover-is-active');
      }
    }
  }
}
